import _ from "lodash";
import InvalidSVG from "../../resources/svg/functional/InvalidSVG";
import ValidSVG from "../../resources/svg/functional/ValidSVG";
import { FormikProps } from "formik";

interface CreateWorkValidationIconsProps<T> {
    form: FormikProps<T>;
    names: (keyof T)[];
    wrapClassName?: string;
}

function CreateWorkValidationIcons<T>(props: CreateWorkValidationIconsProps<T>) {
    return (
        <>
            {props.names.some((name) => _.get(props.form.touched, name)) && (
                <div className={props.wrapClassName}>
                    {props.names.some((name) => _.get(props.form.errors, name)) ? (
                        <InvalidSVG className="min-w-8 dmax2:min-w-6 h-8 dmax2:h-6" />
                    ) : (
                        <ValidSVG className="min-w-8 dmax2:min-w-6 h-8 dmax2:h-6" />
                    )}
                </div>
            )}
        </>
    );
}

export default CreateWorkValidationIcons;
